import script from "./SupportIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportIndex.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/SupportIndex.css?vue&type=style&index=0&id=f089c576&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f089c576"]])

export default __exports__